/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TableHeaderEntryModel} from '../../../shared/table/models/table-header-entry.model';
import {BundleSettlementsDetailColumnEnum} from '../models/bundle-settlements-detail-column.enum';
import * as FinancialDataPipes from '../../util/financial-number/pipe/financial-number-data-pipe';
import * as BundleDataPipes from '../../util/bundle-data-pipes';

const bundleSettlementsDetailTable: {
    quantity: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    materialsUnitNetCost: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    materialsTotalNetCost: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    taxRate: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    materialsTotalGrossCost: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    teMinutesAmount: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    teMinutesUnitCost: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    teMinutesAdditionalCost: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    teMinutesTotalCost: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    blueFapiaoNumber: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    deliveryNumber: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    salesDocument: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
    comments: TableHeaderEntryModel<BundleSettlementsDetailColumnEnum>;
} = {
    quantity: {
        code: BundleSettlementsDetailColumnEnum.QUANTITY,
        name: 'Quantity',
        sortable: false,
        widthWeight: 4,
        hasTextAlignRight: true
    },
    materialsUnitNetCost: {
        code: BundleSettlementsDetailColumnEnum.MATERIALS_UNIT_NET_COST,
        name: 'Net price',
        sortable: false,
        widthWeight: 5,
        hasTextAlignRight: true,
        dataPipe: FinancialDataPipes.financialNumberPipe
    },
    materialsTotalNetCost: {
        code: BundleSettlementsDetailColumnEnum.MATERIALS_TOTAL_NET_COST,
        name: 'Total net price',
        sortable: false,
        widthWeight: 5,
        hasTextAlignRight: true,
        dataPipe: FinancialDataPipes.financialNumberPipe
    },
    taxRate: {
        code: BundleSettlementsDetailColumnEnum.TAX_RATE,
        name: 'Tax rate',
        sortable: false,
        widthWeight: 5,
        dataPipe: BundleDataPipes.percentPipe
    },
    materialsTotalGrossCost: {
        code: BundleSettlementsDetailColumnEnum.MATERIALS_TOTAL_GROSS_COST,
        name: 'Total amount',
        sortable: false,
        widthWeight: 6,
        hasTextAlignRight: true,
        dataPipe: FinancialDataPipes.financialNumberPipe
    },
    teMinutesAmount: {
        code: BundleSettlementsDetailColumnEnum.TE_AMOUNT,
        name: 'Quantity',
        sortable: false,
        widthWeight: 5,
        hasTextAlignRight: true
    },
    teMinutesUnitCost: {
        code: BundleSettlementsDetailColumnEnum.TE_UNIT_COST,
        name: 'Price per minute',
        sortable: false,
        widthWeight: 7,
        hasTextAlignRight: true,
        dataPipe: FinancialDataPipes.financialNumberPipe
    },
    teMinutesAdditionalCost: {
        code: BundleSettlementsDetailColumnEnum.TE_ADDITIONAL_COSTS,
        name: 'Additional costs',
        sortable: false,
        widthWeight: 6,
        hasTextAlignRight: true,
        dataPipe: FinancialDataPipes.financialNumberPipe
    },
    teMinutesTotalCost: {
        code: BundleSettlementsDetailColumnEnum.TE_TOTAL_COST,
        name: 'Total amount',
        sortable: false,
        widthWeight: 7,
        hasTextAlignRight: true,
        dataPipe: FinancialDataPipes.financialNumberPipe
    },
    blueFapiaoNumber: {
        code: BundleSettlementsDetailColumnEnum.BLUE_FAPIAO_NUMBER,
        name: 'Blue fapiao',
        sortable: false,
        widthWeight: 5
    },
    deliveryNumber: {
        code: BundleSettlementsDetailColumnEnum.DELIVERY_NUMBER,
        name: 'Delivery note',
        sortable: false,
        widthWeight: 7
    },
    salesDocument: {
        code: BundleSettlementsDetailColumnEnum.SALES_DOCUMENT,
        name: 'Sales document',
        sortable: false,
        widthWeight: 7
    },
    comments: {
        code: BundleSettlementsDetailColumnEnum.COMMENTS,
        name: 'Comments',
        sortable: false,
        widthWeight: 6,
        hasTextAlignRight: true,
        hasFloatContent: true
    }
};

export default bundleSettlementsDetailTable;
